import React from 'react'
import styles from "./Marketplace.module.scss";
import { XCircle } from 'react-feather'
import { states, statesFull } from '../../constants/states';
import { HELP_WITH_FILTERS, INDUSTRY_MAPPINGS, LIFESTAGE_MAPPINGS } from './Filters/FilterMappings';
function CurrentFilters(props) {
    const { currentFiltersArray, clearSpecficFilter } = props;
    const stage = LIFESTAGE_MAPPINGS
    const type = INDUSTRY_MAPPINGS
    const help = HELP_WITH_FILTERS

    let stateIndex = states.findIndex(x => x === currentFiltersArray[0]);

    const state = currentFiltersArray[0] !== 0 && (<span className={styles.currentFilter}>Located in {statesFull[stateIndex]}<XCircle className={styles.xButton} onClick={() => clearSpecficFilter("state")} /></span>)
    const industryType = currentFiltersArray[1] !== 0 && (<span className={styles.currentFilter}>Specializes in {type[currentFiltersArray[1] - 1].text}<XCircle className={styles.xButton} onClick={() => clearSpecficFilter("industryType")} /></span>)
    const lifeStage = currentFiltersArray[2] !== 0 && (<span className={styles.currentFilter}>Works with {stage[currentFiltersArray[2] - 1].text}<XCircle className={styles.xButton} onClick={() => clearSpecficFilter("lifeStage")} /></span>)
    const helpWith = currentFiltersArray[3] !== 0 && (<span className={styles.currentFilter}>Helps with {help[currentFiltersArray[3] - 1].text}<XCircle className={styles.xButton} onClick={() => clearSpecficFilter("helpWith")} /></span>)


    return (
        <div className={styles.currentFiltersContainer}>
            {state}
            {industryType}
            {lifeStage}
            {helpWith}
        </div>
    )
}

export default CurrentFilters
